import React, { useEffect, useState } from 'react';
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { Helmet } from "react-helmet-async";

import fi from "../assets/Fi.webp";
import p1 from "../assets/P1.png";
import p2 from "../assets/P2.png";
import p3 from "../assets/P3.png";
import p4 from "../assets/P4.png";
import BBBBB from "../assets/chooseR.webp";
import { useNavigate } from 'react-router-dom'; 
import { useRef } from "react";
import { toast, ToastContainer } from "react-toastify";




const Finance = () => {
  
const [openDropdown, setOpenDropdown] = useState(null);
  const navRef = useRef(null);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navRef.current && !navRef.current.contains(event.target)) {
        setOpenDropdown(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const toggleDropdown = (dropdown) => {
    setOpenDropdown(openDropdown === dropdown ? null : dropdown);
  };



      const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
        const [isServicesOpen, setIsServicesOpen] = useState(false);
        const [isIndustriesOpen, setIsIndustriesOpen] = useState(false);
        const [isCompanyOpen, setIsCompanyOpen] = useState(false);
      
        const toggleMobileMenu = () => {
          setIsMobileMenuOpen(!isMobileMenuOpen);
        };
      
        const toggleServicesDropdown = () => {
          setIsServicesOpen(!isServicesOpen);
        };
      
        const toggleIndustriesDropdown = () => {
          setIsIndustriesOpen(!isIndustriesOpen);
        };
      
        const toggleCompanyDropdown = () => {
          setIsCompanyOpen(!isCompanyOpen);
        };
const navigate = useNavigate();
 
  const handleClick = () => {
    navigate("/Contact#contact-section");
  };
const cardVariants = {
  hidden: { opacity: 0, y: 30 },
  show: (i) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: i * 0.2,
      duration: 0.6,
      ease: "easeOut",
    },
  }),
};

const features = [
  {
    number: "01",
    title: "Enhanced security",
    description:
      "Traditional FTP lacks encryption, but this solution secures every transfer with SFTP to prevent unauthorized access.",
    icon: p1,
    cardBg: "bg-[#FEEFE9]",
    textColor: "text-[#FF6A00]",
  },
  {
    number: "02",
    title: "Efficiency & automation",
    description:
      "The program automates file transfers end-to-end, reducing human error and boosting operational efficiency.",
    icon: p2,
    cardBg: "bg-[#E7EBFF]",
    textColor: "text-[#4C6FFF]",
  },
  {
    number: "03",
    title: "Streamlined operations",
    description:
      "Post-transfer cleanup minimizes duplication and risks, keeping the environment secure and tidy.",
    icon: p3,
    cardBg: "bg-[#F3E9FE]",
    textColor: "text-[#914DFF]",
  },
  {
    number: "04",
    title: "User friendly interface",
    description:
      "Lentera’s file mover enables secure transfers through a simple, user-friendly interface.",
    icon: p4,
    cardBg: "bg-[#E8FFF0]",
    textColor: "text-[#00B44B]",
  },
];


// Left Animation Controller
const leftControls = useAnimation();
const [leftRef, inViewLeft] = useInView({ threshold: 0.3 });

useEffect(() => {
  if (inViewLeft) {
    leftControls.start("show");
  } else {
    leftControls.start("hidden");
  }
}, [inViewLeft]);

// Right Animation Controller
const rightControls = useAnimation();
const [rightRef, inViewRight] = useInView({ threshold: 0.3 });

useEffect(() => {
  if (inViewRight) {
    rightControls.start("show");
  } else {
    rightControls.start("hidden");
  }
}, [inViewRight]);



const textControls = useAnimation();
  const cardsControls = useAnimation();

  const [textRef, textInView] = useInView({ triggerOnce: false, threshold: 0.3 });
  const [cardsRef, cardsInView] = useInView({ triggerOnce: false, threshold: 0.3 });

  useEffect(() => {
    if (textInView) {
      textControls.start("visible");
    } else {
      textControls.start("hidden");
    }
  }, [textInView, textControls]);

  useEffect(() => {
    if (cardsInView) {
      cardsControls.start("visible");
    } else {
      cardsControls.start("hidden");
    }
  }, [cardsInView, cardsControls]);

  const fadeInFromLeft = {
    hidden: { opacity: 0, x: -50 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.8, ease: "easeOut" } },
  };

  const fadeInFromRight = {
    hidden: { opacity: 0, x: 50 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.8, ease: "easeOut" } },
  };

   const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
const [isOpen, setIsOpen] = useState(false);

  const toggleSlider = () => {
    setIsOpen((prev) => !prev);
  };
 
  return (
    <>
    <Helmet>
        <title>Financial Services & Secure File Transfers | LENTERA Finance Solutions.</title>
        <meta name="description" content="Improve security, automate operations, and streamline money management for individuals and businesses."/>
        <meta name="keywords" content="LENTERA finance services, money management solutions, financial planning support, streamlined financial operations.Education "/>
      </Helmet>
    <ToastContainer position="top-right" autoClose={3000} />
   <div className="w-full font-[Poppins]">
   
  

  


<section className="w-full bg-[#F9FFDD] py-20 px-4 sm:px-6">
  <div className="w-full max-w-[1312px] mx-auto flex flex-col lg:flex-row items-center justify-between gap-10">
    
    {/* Left Column – 60% with animation */}
    <motion.div
      className="w-full lg:w-[60%]"
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.8, ease: "easeOut" }}
    >
      <h5 className="text-[#212129] text-sm font-semibold uppercase mb-3 tracking-wide">
        Finance Service
      </h5>

      <h2 className="text-[#1E1E1E] text-[40px] md:text-[48px] font-extrabold leading-tight mb-6">
        Brighten your financial <br className="hidden sm:block" /> future by today
      </h2>

      <p className="text-[#4A4A4A] text-base leading-relaxed max-w-[580px]">
        Take full control of your money with powerful financial tools,<br />
        personalized expert guidance, and bold, easy-to-use solutions — all <br />
        designed to help you make smarter decisions and start seeing results <br />
        today.      </p>
    </motion.div>

    {/* Right Column – 40% with animation */}
    <motion.div
      className="w-full lg:w-[40%] flex justify-center"
      initial={{ opacity: 0, x: 60 }}
      whileInView={{ opacity: 1, x: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
    >
      <img src={fi} alt="Finance Illustration"  className="w-full max-w-[500px] h-auto object-contain" />
      {/* <img
        src={WebDevelopmentImage}
        alt="Web Developer Illustration"
        className="w-full max-w-[500px] h-auto object-contain"
      /> */}
    </motion.div>

  </div>
</section>


<section className="font-poppins bg-white py-16 px-4 md:px-8 lg:px-16 overflow-x-hidden">
  {/* Overview Heading and Description */}
  <div className="text-center max-w-4xl mx-auto mb-12">
    <h2 className="text-[36px] weight-[600] md:text-[42px] lg:text-[48px] font-semibold text-[#1A1A1A] leading-tight mb-4">
      Overview
    </h2>
    <p className="text-[#3D3D3D] text-[16px] leading-relaxed">
      Secure file transfers protect sensitive data, making it crucial to switch from FTP to the safer SFTP protocol. <br className="hidden md:block" />
      Lentera’s FTP to SFTP File Mover speeds up and secures this transition.
    </p>
  </div>

  {/* Content Box */}
  <div className="bg-[#F3EFFF] rounded-[60px] px-8 py-12 md:px-12 lg:px-16 max-w-7xl mx-auto flex flex-col-reverse lg:flex-row items-center justify-between relative overflow-hidden">
    
    {/* Left Text */}
    <div className="w-full lg:w-6/12 text-left">
      <h3 className="text-[36px] sm:text-[42px] lg:text-[48px] font-bold text-[#1A1A1A] mb-6 leading-snug">
        What is financials <br /> services?
      </h3>
      <p className="text-[#3D3D3D] text-[16px] leading-relaxed">
        Financial services cover businesses that manage money, including banks, real estate, investments, and insurance. They offer services like banking, investing, insurance, and financial planning. Their purpose is to help individuals and organizations manage finances effectively.
      </p>
    </div>

    {/* Right Image */}
    <div className="w-full lg:w-6/12 flex justify-center mb-8 lg:mb-0">
      <img
        src={require("../assets/FF.webp")} // ✅ Replace with your actual image path
        alt="Finance Illustration"
        className="max-w-[480px] w-full h-auto object-contain"
      />
    </div>
  </div>
</section>




  <section className="bg-[#1c1c1c] text-white py-20 px-4 sm:px-6 md:px-10 lg:px-20">
  {/* Heading */}
  <div className="flex flex-col lg:flex-row justify-between items-start gap-8 mb-16">
    <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold leading-snug">
      Benefits of Financial <br className="hidden md:block" /> Services
    </h2>
    <p className="text-base text-[#E1E1E1] max-w-xl">
      Financial services provide essential support for managing money, enabling
      individuals and businesses to save, invest, borrow, and plan for a secure
      financial future.
    </p>
  </div>

  {/* Cards */}
  <div className="flex flex-wrap justify-center gap-6">
    {features.map((item, index) => (
      <motion.div
        key={index}
        custom={index}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.3 }}
        variants={cardVariants}
        className="relative bg-white rounded-[28px] p-4 max-w-[310px] w-full min-h-[292.82px] flex-shrink-0"
      >
        {/* Top Icon */}
        <div className="absolute -top-6 left-1/2 -translate-x-1/2">
          <img src={item.icon} alt={`icon ${item.number}`} className="w-10 h-10" />
        </div>

        {/* Card Content */}
        <div className={`mt-8 ${item.cardBg} p-4 rounded-[20px]`}>
          <h4 className={`text-[18px] font-semibold mb-1 ${item.textColor}`}>
            {item.number}
          </h4>
          <h3 className="text-[#1c1c1c] text-[16px] font-semibold mb-2">
            {item.title}
          </h3>
          <p className="text-[#3d3d3d] text-sm leading-relaxed">
            {item.description}
          </p>
        </div>
      </motion.div>
    ))}
  </div>
</section>


<section className="bg-white font-poppins py-16 px-4 md:px-12 lg:px-20 overflow-x-hidden">
  {/* Heading */}
  <div className="text-center max-w-4xl mx-auto mb-12">
    <h2 className="text-[36px] sm:text-[42px] lg:text-[48px] font-bold text-[#1A1A1A] leading-tight mb-4">
      Why choose us
    </h2>
    <p className="text-[#3D3D3D] text-[16px] leading-relaxed">
      Discover what sets us apart — unmatched expertise, innovation, <br className="hidden sm:inline-block" />
      and results.
    </p>
  </div>

  {/* Main Content */}
  <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-start gap-10 lg:gap-20">

    {/* Left Grouped Image */}
    <div className="w-full lg:w-6/12">
      <div className="bg-[#F3EFFF] rounded-[40px] px-6 py-10 h-full">
        <img
          src={require("../assets/II.webp")} // replace with actual left image (illustration)
          alt="Why Choose Illustration"
          className="w-full h-auto object-contain"
        />
      </div>
    </div>

    {/* Right Grouped Cards Image */}
   <div className="w-full lg:w-6/12 flex justify-center">
  <img
    src={BBBBB}
    alt="Why Choose Features"
    className="w-full h-auto object-contain"
  />
</div>
  
  </div>
</section>
    </div>
    </>
  )
}

export default Finance